import { ILeague } from '../../types';
import { EnhancedTableProps } from './types';
import { visuallyHidden } from '@mui/utils';
import { TableSortLabel, TableHead, TableRow, TableCell, Box } from '@mui/material';

export function TableMatch(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, leagues } = props
  
  const createSortHandler = (property: keyof ILeague) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property)
  }

  const array: any = Array.from(new Set(leagues?.map((item: any) =>
    Object.keys(item)).flat().filter((key: string) => key !== 'id' && key !=='createdDate' && key !== 'imageUrl')))
  
  return (
    <TableHead>
      <TableRow>
        {leagues?.length > 0 && array?.map((headCell: any) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell)}
              className="capitalize font-bold w-max"
            >
              {headCell}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
